// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1tEZd","author":"Table_author__V6C_i","authorImage":"Table_authorImage__3sJ8r","unreadRow":"Table_unreadRow__3MByO"};